// dataExample data {1992: val, 1993: val, …}

const APP_URL = 'http://www.iwkoeln.de/presse/mediathek/beitrag/320684';
const EMBED_URL = 'http://www.iwkoeln.de/__extendedmedia_resources/320689/index.html';
const APP_URL_ENCODED = encodeURIComponent(APP_URL);

export function getTimeLineValues(data) {
  // remove also last key from array, because it´s not a year
  const yearsFromData = Object.keys(data).slice(0, Object.keys(data).length-1);
  return yearsFromData.map(el => parseInt(el, 10));
}

export function getEmbedCode() {
  // const path = window.location.pathname || '';

  return (`<iframe width="100%" height="840" src="${EMBED_URL}" frameborder="0" allowfullscreen></iframe>`);
}

export const getHrefFb = () => {
  return `https://www.facebook.com/sharer/sharer.php?u=${APP_URL_ENCODED}&t=Interaktive%20Grafik%3A%20Wer%20zur%20Mittelschicht%20geh%C3%B6rt`;
}

export const getHrefTw = () => {
  return `https://twitter.com/intent/tweet?url=${APP_URL_ENCODED}&text=Interaktive%20Grafik%20von%20%40iw_koeln%3A%20Wer%20zur%20Mittelschicht%20geh%C3%B6rt`;
}

export const getHrefGp = () => {
  return `https://plus.google.com/share?url=${APP_URL_ENCODED}&type=st&rsz=1&client=3`;
}



/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/